import { render, staticRenderFns } from "./SelectMarket.vue?vue&type=template&id=d2a524b6&scoped=true"
import script from "./SelectMarket.vue?vue&type=script&lang=js"
export * from "./SelectMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a524b6",
  null
  
)

export default component.exports